export class CharacteristicSubscriptionError extends Error {};